<p-dialog appDialogoPadrao="pi pi-building" descricao="Escolha a estrutura na lista." [header]="header()" [visible]="visivel()" (visibleChange)="$event ? null : fechar()" [style]="{ width: '760px', maxWidth: '96vw' }" [closeOnEscape]="true">
    <div class="estrutura-modal-body">
        @if (buscando()) {
            <div class="flex items-center justify-center gap-2 py-10 text-surface-500">
                <i class="pi pi-spin pi-spinner text-xl" aria-hidden="true"></i>
                <span class="text-sm">Carregando estruturas...</span>
            </div>
        } @else {
            <p-tree
                [value]="estruturaTree()"
                [filter]="true"
                filterMode="lenient"
                filterPlaceholder="Pesquisar por código, sigla ou descrição..."
                selectionMode="single"
                [metaKeySelection]="false"
                [selection]="selecionado()"
                (onNodeSelect)="selecionado.set($event.node)"
                (onNodeUnselect)="selecionado.set(null)"
                scrollHeight="400px"
                styleClass="estrutura-modal-tree w-full"
            >
                <ng-template pTemplate="default" let-node>
                    <div class="tree-node-row">
                        <code class="tree-node-code">{{ node.data?.id }}</code>
                        <span class="tree-node-desc">{{ node.data?.descricao }}</span>
                    </div>
                </ng-template>
            </p-tree>
            @if (estruturaTree().length === 0) {
                <div class="flex flex-col items-center gap-2 py-10 text-surface-400">
                    <i class="pi pi-inbox text-3xl" aria-hidden="true"></i>
                    <span class="text-sm">Nenhuma estrutura encontrada.</span>
                </div>
            }
        }
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" text (click)="fechar()" ariaLabel="Cancelar seleção de estrutura" />
        <p-button label="Selecionar" icon="pi pi-check" [disabled]="!selecionado()" (click)="confirmarSelecao()" ariaLabel="Confirmar estrutura selecionada" />
    </ng-template>
</p-dialog>
